const contentWidth = {
  fixed: {
    maxWidth: "1008px",
  },
  fluid: {
    maxWidth: "100%",
  },
}

export default {
  contentWidth,
}
